import { render } from "./ModuleInscriptionCard.vue?vue&type=template&id=8d2978de&scoped=true"
import script from "./ModuleInscriptionCard.vue?vue&type=script&lang=js"
export * from "./ModuleInscriptionCard.vue?vue&type=script&lang=js"

import "./ModuleInscriptionCard.vue?vue&type=style&index=0&id=8d2978de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2978de"]])

export default __exports__